import { useEffect } from 'react';
import ReactPixel from 'react-facebook-pixel';

const useFacebookPixel = (pixelId) => {
  useEffect(() => {
    ReactPixel.init(pixelId);
    ReactPixel.pageView();
  }, [pixelId]);
};

export default useFacebookPixel;
